'use strict';

/*#__NO_SIDE_EFFECTS__*/
const noop = (any) => any;

exports.noop = noop;
//# sourceMappingURL=noop.cjs.map
